import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Seguir sin saber por qué el dinero no alcanza',
    cost: 'Otro mes de escasez'
  }, {
    without: 'No tener protección contra la envidia',
    cost: 'Tu progreso frenado por otros'
  }, {
    without: 'Depender de santerías caras para cada limpieza',
    cost: 'Miles de pesos en productos'
  }, {
    without: 'No saber qué hacer cuando aparece un gasto imprevisto',
    cost: 'Pánico y deuda'
  }, {
    without: 'Seguir con la energía pesada acumulada en tu casa',
    cost: 'Bloqueo constante'
  }, {
    without: 'No tener las herramientas para activar el dinero',
    cost: 'Oportunidades que no llegan'
  }, {
    without: 'Seguir con los mandatos de pobreza de tu familia',
    cost: 'Una vida entera de escasez'
  }, {
    without: 'No poder blindar tu hogar contra influencias externas',
    cost: 'Vulnerabilidad permanente'
  }, {
    without: 'Sin un sistema',
    cost: 'La próxima semana será igual. El próximo mes será igual. Y probablemente el próximo año también.'
  }];
  return <Section data-id="element-14">
      <div className="text-center mb-12" data-id="element-15">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-darkGreen" data-id="element-16">
          <span className="mr-3" data-id="element-17">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="hidden md:block" data-id="element-19">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-20">
            <div className="font-serif font-bold text-lg text-brand-goldDark" data-id="element-21">
              Sin el Código de Blindaje Argentino
            </div>
            <div className="font-serif font-bold text-lg text-brand-error" data-id="element-22">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-23">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-error/10 bg-white/70" data-id="element-24">
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-25">
                  {row.without}
                </div>
                <div className="text-sm text-brand-error/90 font-medium" data-id="element-26">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-27">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-error/10 bg-white/70 space-y-2" data-id="element-28">
              <p className="text-sm font-medium text-brand-text" data-id="element-29">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-error/90 font-medium" data-id="element-30">
                <span className="text-brand-error shrink-0" data-id="element-31">→</span>
                <span className="text-sm" data-id="element-32">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-33"></div>
    </Section>;
};